import { graphql } from '../graphql/graphql';

export const textFragment = graphql(`
  fragment Text on Text {
    __typename
    text
    bold
    mark
    blur
    colorToken
  }
`);
